import { useEffect } from 'react'
import ClientService from '../services/client.service'
import RoleService from '../services/role-sg3.service'
import ProfileService from '../services/role-auth.service'
import { useTranslation } from "react-i18next";

const useGetClients = (sourceClientList, setSourceClients) => {
    
    useEffect(()=> {
        const getSourceClients = async () => {
            try {
                const serviceResponse = await ClientService.getAllClients();
                const response = serviceResponse.data;
                setSourceClients(response)
            }
            catch (error) {
            }
        }
        
        if (sourceClientList === null) {
            getSourceClients()
        }
    }, [sourceClientList, setSourceClients]);
    
}

const useGetProfiles = (sourceProfileList, setSourceProfiles, addDefaultSelectItem) => {
    const { t } = useTranslation();
        
    useEffect(()=> {
        const getSourceClients = async () => {
            try {
                const serviceResponse = await ProfileService.getAllProfiles();
                const response = serviceResponse.data;

                if (addDefaultSelectItem) {
                    response.unshift({id: null, name: t('data-lang-lbl-select')});
                }

                setSourceProfiles(response)
            }
            catch (error) {
            }
        }
        
        if (sourceProfileList === null) {
            getSourceClients()
        }
    }, [t, sourceProfileList, setSourceProfiles, addDefaultSelectItem]);
}

const useGetRoles = (sourceRoleList, setSourceRoles, addDefaultSelectItem) => {
    const { t } = useTranslation();
        
    useEffect(()=> {
        const getSourceClients = async () => {
            try {
                const serviceResponse = await RoleService.getAllRoles();
                const response = serviceResponse.data;

                if (addDefaultSelectItem) {
                    response.unshift({id: null, nombre: t('data-lang-lbl-select')});
                }

                setSourceRoles(response)
            }
            catch (error) {
            }
        }
        
        if (sourceRoleList === null) {
            getSourceClients()
        }
    }, [t, sourceRoleList, setSourceRoles, addDefaultSelectItem]);

}

const useGetClientPermissionsTableSchema = (dataTableSchema, setClienPermissionstDataTableSchema, userClientId) => {    
    useEffect(()=> {
        const getDataAndSchema = async () => {

            const serviceResponse = await ClientService.getAllPermissions(userClientId, dataTableSchema.pageNumber, dataTableSchema.pageSize, dataTableSchema.filters, dataTableSchema.orderField, dataTableSchema.orderAsc);
            const response = serviceResponse.data;

            setClienPermissionstDataTableSchema(response);
        }
        
        if ((dataTableSchema === null || dataTableSchema.data === null) && userClientId) {
            getDataAndSchema()
        }
    }, [dataTableSchema, setClienPermissionstDataTableSchema, userClientId]);
}

const useGetUserPermissionsTableSchema = (dataTableSchema, setClienPermissionstDataTableSchema, userClientId, userId) => {    
    useEffect(()=> {
        const getDataAndSchema = async () => {

            const serviceResponse = await ClientService.getAllPermissionsByUser(userId, userClientId, dataTableSchema.pageNumber, dataTableSchema.pageSize, dataTableSchema.filters, dataTableSchema.orderField, dataTableSchema.orderAsc);
            const response = serviceResponse.data;

            setClienPermissionstDataTableSchema(response);
        }
        
        if ((dataTableSchema === null || dataTableSchema.data === null) && userClientId && userId) {
            getDataAndSchema()
        }
    }, [dataTableSchema, setClienPermissionstDataTableSchema, userClientId, userId]);
}
    
export { useGetRoles, useGetProfiles, useGetClients, useGetClientPermissionsTableSchema, useGetUserPermissionsTableSchema }